import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["error", "checked"];
// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Styles
import './Checkbox.scss';
var Checkbox = function Checkbox(props) {
  var error = props.error,
    checked = props.checked,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    animate = _React$useState2[0],
    setAnimate = _React$useState2[1];
  var _React$useState3 = React.useState(props.checked),
    _React$useState4 = _slicedToArray(_React$useState3, 1),
    initiallyChecked = _React$useState4[0];
  React.useEffect(function () {
    if (props.checked !== initiallyChecked) setAnimate(true);
  }, [props.checked]);
  return /*#__PURE__*/React.createElement("div", _extends({
    contentEditable: false,
    className: classNames('Checkbox', {
      error: error,
      checked: checked,
      animate: animate
    })
  }, otherProps), /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    className: "Icon checkbox-animated",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "16",
    height: "16",
    fill: "#CBCED2",
    rx: "2",
    className: "fill"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M4 8l3 3 5-5",
    strokeWidth: "2",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    className: "tick"
  })), /*#__PURE__*/React.createElement("rect", {
    width: "15",
    height: "15",
    x: ".5",
    y: ".5",
    fill: "none",
    stroke: "#333D4E",
    rx: "2",
    className: "border"
  })));
};
Checkbox.propTypes = {
  checked: PropTypes.bool,
  error: PropTypes.bool
};
export default Checkbox;